import repository from 'dy-frontend-http-repository/lib/repository';
import { TaskKanbanResource } from 'dy-frontend-http-repository/lib/modules/TaskKanban/resources';
import domain from './domain';

// Get kanban board
export const fetchTaskKanbanBoard = domain.createEffect<void, TaskKanbanResource>({
    name: 'fetchTaskKanbanBoard',
    handler: async () => {
        return await repository.taskKanban().get();
    },
});
